import { FullState } from '../../store';
import { createSelector } from 'reselect';
import { PoiAdminState } from '../../types/poiAdmin';
import {
  CustomPointOfInterest,
  LocationType,
  PoiCodePreference,
  PoiCreateMinimumRole
} from '../../common/api/spidertracks-sdk/types/PointOfInterest';

export const getPoiAdmin = (state: FullState): PoiAdminState => state.poiAdmin;

export const getPoiCodePreference = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): PoiCodePreference | undefined => poiAdmin.poiCodePreference
);

export const getPoiCreateMinimumRole = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): PoiCreateMinimumRole | undefined => poiAdmin.poiCreateMinimumRole
);

export const getSelectedCustomPoiIds = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): number[] => poiAdmin.selectedCustomPoiIds
);

export const getCustomPois = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): CustomPointOfInterest[] => poiAdmin.customPois
);

export const getCustomPoisTotal = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): number => poiAdmin.customPoisTotal
);

export const getCustomPoisPageNumber = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): number => poiAdmin.customPoisPageNumber
);

export const getLocationTypes = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): LocationType[] => poiAdmin.locationTypes
);

export const getPoisLoading = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): boolean => poiAdmin.poisLoading
);

export const getPoisLoadingFailed = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): boolean => poiAdmin.poisLoadingFailed
);

export const getLocationTypesLoading = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): boolean => poiAdmin.locationTypesLoading
);

export const getLocationTypesLoadingFailed = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): boolean => poiAdmin.locationTypesLoadingFailed
);

export const getPoisDeleteSuccess = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): boolean => poiAdmin.poisDeleteSuccess
);

export const getPoisDeleteFailed = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): boolean => poiAdmin.poisDeleteFailed
);

export const getPoiPreferenceUpdating = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): boolean => poiAdmin.poiPreferenceUpdating
);

export const getPoiPreferenceUpdateSuccess = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): boolean => poiAdmin.poiPreferenceUpdateSuccess
);

export const getPoiPreferenceUpdateFailed = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): boolean => poiAdmin.poiPreferenceUpdateFailed
);

export const getSelectedCustomPoi = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): CustomPointOfInterest | undefined => poiAdmin.selectedCustomPoi
);

export const getEditingCustomPoi = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): Partial<CustomPointOfInterest> | undefined => poiAdmin.editingCustomPoi
);

export const getPoiUpdating = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): boolean => poiAdmin.poiUpdating
);

export const getPoiUpdateSuccess = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): boolean => poiAdmin.poiUpdateSuccess
);

export const getPoiUpdateFailed = createSelector(
  [getPoiAdmin],
  (poiAdmin: PoiAdminState): boolean => poiAdmin.poiUpdateFailed
);
